import { render } from "./QuizControls.vue?vue&type=template&id=0f162d56"
import script from "./QuizControls.vue?vue&type=script&lang=js"
export * from "./QuizControls.vue?vue&type=script&lang=js"
script.render = render

export default script